import {Component, OnDestroy, OnInit} from "@angular/core";
import {StatistiqueEgalimDTO} from "../../../core/dtos/egalim/statistique-egalim-dto";
import {GraphQLService} from "../../../core/services/technique/graphql.service";
import {UtilsService} from "../../../core/utils/utils.service";
import {Subscription} from "rxjs";
import {StatistiquesEGAlimService} from "../../../core/services/egalim/statistiques-egalim.service";
import {FamilleEgalimEnum} from "../../../core/enums/egalim/famille-egalim-enum";
import {InternationalizationService} from "../../../core/services/i8n/i8n.service";
import {AppellationEgalimGroupEnum} from "../../../core/enums/egalim/appellation-egalim-group-enum";
import moment from "moment";


@Component({
  selector: 'yo-statistiques-egalim-details-dialog',
  templateUrl: './statistiques-egalim-details-dialog.component.html',
  styleUrls: ['./statistiques-egalim-details-dialog.component.scss']
})
export class StatistiquesEgalimDetailsDialogComponent implements OnInit, OnDestroy {

  ROUND_COUNT = 2;

  isDisplayed: boolean = false;
  isLoading: boolean = false;
  statistique: StatistiqueEgalimDTO;

  subOpenStatistiqueDetails: Subscription;

  public readonly rows = this.getEnumKeysInOrder(FamilleEgalimEnum)
  public readonly columns = this.initColumns();

  constructor(public i8nSvc: InternationalizationService,
              private statistiqueEGAlimSvc: StatistiquesEGAlimService,
              private graphQlSvc: GraphQLService,
              private utilsSvc: UtilsService) {
  }

  ngOnInit(): void {
    this.initSubOpenStatistiqueDetails();
  }

  ngOnDestroy(): void {
    this.utilsSvc.unsubscribe(this.subOpenStatistiqueDetails);
  }

  initSubOpenStatistiqueDetails() {
    this.subOpenStatistiqueDetails = this.statistiqueEGAlimSvc.onOpenStatistiquesEGAlimDetailsDialog$.subscribe(id => {
      this.isDisplayed = true;
      this.getStatistiques(id);
    });
  }

  private getEnumKeysInOrder<T extends object>(enumObj: T) {
    return Object.values(enumObj)
      .filter(value => typeof value === 'number')
      .map(value => enumObj[value as keyof T]);
  }

  getStatistiques(id: number) {
    this.isLoading = true;
    this.graphQlSvc.sendQuery(
      `{
        allStatistiqueEGAlim(filters: {
            ids: [${id}]
        })
          {
            id,
            site {
                id,
                libelle
            },
            annee,
            dateGeneration,
            dateDiagnosticSent,
            pointTeledeclaration {
                libelle,
                siret
            },
            isDiagnosticSent,
            isConforme,
            lignes {
              familleEGAlim,
              colonnes {
                appellationGroup,
                montant {
                  value,
                  uniteMonetaire
                }
              }
            }
          }
        }`
    ).subscribe(result => {
      if (result)
        this.statistique = result.allStatistiqueEGAlim[0];
      this.isLoading = false;
    });
  }

  closePopup() {
    this.isDisplayed = false;
  }

  getStatistic(famille: FamilleEgalimEnum, appellation: AppellationEgalimGroupEnum) {
    if (this.statistique && appellation != undefined)
      return this.statistique.lignes
        .filter(l => l.familleEGAlim == famille)
        [0].colonnes.filter(l => l.appellationGroup == appellation)[0].montant.value;
    return null;
  }

  getTotal(appellation: AppellationEgalimGroupEnum) {
    if (this.statistique && appellation!= undefined)
      return this.statistique.lignes
        .map(l => l.colonnes.filter(c => c.appellationGroup == appellation)[0])
        .reduce(((l1, l2) => l1 + l2.montant.value), 0);
    return null;
  }

  displayValue(value: number) {
    if (value > 0)
      return `${value.toFixed(this.ROUND_COUNT)} €`;
    else if (value == 0)
      return '-';
    return null;
  }

  isSiqo(appellation: string) {
    switch (AppellationEgalimGroupEnum[appellation]) {
      case AppellationEgalimGroupEnum.LABEL_ROUGE:
      case AppellationEgalimGroupEnum.AOP_AOC_IGP_STG:
        return true;
      default:
        return false;
    }
  }

  isAutre(appellation: string) {
    switch (AppellationEgalimGroupEnum[appellation]) {
      case AppellationEgalimGroupEnum.NIV_2_HVE:
      case AppellationEgalimGroupEnum.ECO_PECHE_DURABLE:
      case AppellationEgalimGroupEnum.RUP:
      case AppellationEgalimGroupEnum.COMMERCE_EQUITABLE:
      case AppellationEgalimGroupEnum.FERMIER:
        return true;
      default:
        return false;
    }
  }

  isCritere(appellation: string) {
    switch (AppellationEgalimGroupEnum[appellation]) {
      case AppellationEgalimGroupEnum.EXTERNALITES_ENV:
      case AppellationEgalimGroupEnum.PERF_ENV_APPRO_DIRECT:
        return true;
      default:
        return false;
    }
  }

  needLeftBorder(appellation: string) {
    switch (AppellationEgalimGroupEnum[appellation]) {
      case AppellationEgalimGroupEnum.LABEL_ROUGE:
      case AppellationEgalimGroupEnum.NIV_2_HVE:
      case AppellationEgalimGroupEnum.EXTERNALITES_ENV:
        return true;
      default:
        return false;
    }
  }

  needRightBorder(appellation: string) {
    switch (AppellationEgalimGroupEnum[appellation]) {
      case AppellationEgalimGroupEnum.AOP_AOC_IGP_STG:
      case AppellationEgalimGroupEnum.FERMIER:
      case AppellationEgalimGroupEnum.PERF_ENV_APPRO_DIRECT:
        return true;
      default:
        return false;
    }
  }

  private initColumns() {
    let working = this.getEnumKeysInOrder(AppellationEgalimGroupEnum);
    working.splice(8, 0, undefined);
    working.splice(3, 0, undefined);
    return working;
  }

  getDateGeneration() {
    return moment(this.statistique?.dateGeneration).format("DD/MM/YYYY HH:mm:ss");
  }
}
